import { Injectable } from '@angular/core';
import { EMPTY, Observable, of } from 'rxjs';
import { DataSourceMeta, DocAnnotation, TextItem } from '../models';
import { Loader } from './loader';

@Injectable()
export class NoLoaderService extends Loader {
    public constructor() {
        super();
    }

    public GetPdf(): Observable<File> {
        return of(new File([], 'empty'));
    }
    public GetPdfDataSource(): Observable<DataSourceMeta[]> {
        return of(null);
    }
    public SavePdf(pdf: File): Observable<void> {
        return EMPTY;
    }
    public GetTextItems(): Observable<TextItem[]> {
        return of(null);
    }
    public GetAnnotations(): Observable<DocAnnotation[]> {
        return of(null);
    }
    public GetSelectedStampId(): string {
        return null;
    }
    public Dispose() {}
}
